module.exports = __webpack_public_path__ + "static/image_11-51a80fb52a95540a48c34bbd099c104e.jpg";